import { DialogContent, Button, Stack, Typography } from "@mui/material";
import StandardDialog from "./StandardDialog.js";
import ReactionInput from "./ReactionInput.js";
import { useEffect, useRef, useState } from "react";
import { useThemeContext } from "../context/themeContext";

function ReactionsEditorDialog({
  open,
  reactions,
  contentType,
  onSave,
  onClose,
  isFullscreen,
}) {
  const { isTouchDevice } = useThemeContext();
  const [draftReactions, setDraftReactions] = useState(reactions || []);

  // Re-sync draft state whenever the dialog opens so stale values don't persist
  useEffect(() => {
    if (open) {
      setDraftReactions(reactions || []);
    }
  }, [open, reactions]);

  const handleSave = () => {
    onSave({ reactions: draftReactions });
  };

  const reactionInputRef = useRef(null);

  return (
    <StandardDialog
      open={open}
      onClose={onClose}
      isFullscreen={isFullscreen}
      TransitionProps={{ onEntered: () => { if (!isTouchDevice) reactionInputRef.current?.focus(); } }}
    >
      <DialogContent sx={{ p: 2 }}>
        <Typography
          gutterBottom
          variant="body2"
          sx={{ fontWeight: "bold", mb: 1 }}
        >
          Edit reactions
        </Typography>
        <ReactionInput
          ref={reactionInputRef}
          selectedTags={draftReactions}
          onTagsChange={(value) => setDraftReactions(value)}
          contentType={contentType}
          readOnly={false}
        />
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ mt: 2 }}
          spacing={1}
        >
          <Button onClick={onClose} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </Stack>
      </DialogContent>
    </StandardDialog>
  );
}

export default ReactionsEditorDialog;
